import { EditorState, Transaction } from "@tiptap/pm/state";
import { CellSelection } from "prosemirror-tables";
// If using TipTap v2.1+, you can also import from "@tiptap/pm/tables":
// import { CellSelection } from "@tiptap/pm/tables";

/**
 * Selects all cells in the table surrounding the current selection/cursor position.
 */
export function selectTable(
  state: EditorState,
  dispatch?: (tr: Transaction) => void
): boolean {
  if (!state) return false;

  const { $from } = state.selection;

  // 1. Locate the parent table node relative to the selection depth
  let tableDepth = -1;
  for (let d = $from.depth; d > 0; d--) {
    if ($from.node(d).type.name === "table") {
      tableDepth = d;
      break;
    }
  }

  if (tableDepth === -1) return false;

  const tableNode = $from.node(tableDepth);
  const tableStart = $from.start(tableDepth);

  // 2. Identify the absolute positions of the first and last cells
  let firstCellPos: number | null = null;
  let lastCellPos: number | null = null;

  tableNode.descendants((node, pos) => {
    if (node.type.name === "tableCell" || node.type.name === "tableHeader") {
      const absolutePos = tableStart + pos;
      if (firstCellPos === null) {
        firstCellPos = absolutePos;
      }
      lastCellPos = absolutePos;
    }
  });

  if (firstCellPos === null || lastCellPos === null) return false;

  // 3. Dispatch a CellSelection spanning from the first to the last cell
  if (dispatch) {
    const $firstCell = state.doc.resolve(firstCellPos);
    const $lastCell = state.doc.resolve(lastCellPos);
    const selection = new CellSelection($firstCell, $lastCell);
    dispatch(state.tr.setSelection(selection));
  }

  return true;
}